import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { LiveChatWidgetModule, WidgetState, WidgetStateService } from "@livechat/widget-angular";
import { TranslateService } from "@ngx-translate/core";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "src/app/models/auth";
import { AuthService } from "src/app/services/auth.service";
import { EncryptionService } from "src/app/services/encryption.service";
declare global {
  interface Window {
    LC_API?: {
      set_customer_data: (data: any) => void;
      hide_chat_window: () => void;
      destroyChat?: () => void;
    };
  }
}
@Component({
  selector: "logibids-live-chat-widget",
  standalone: true,
  imports: [CommonModule, LiveChatWidgetModule],
  templateUrl: "./live-chat-widget.component.html",
  styleUrl: "./live-chat-widget.component.scss",
})
export class LiveChatWidgetComponent implements OnInit, OnDestroy {
  protected destroy$: Subject<boolean> = new Subject<boolean>();
  profile: User;
  private stateSubscription!: Subscription;
  chatState: WidgetState | null = null;
  name: string = '';
  email: string = '';
  constructor(
    private _authService: AuthService,
    public translate: TranslateService,
    private _EncryptionService: EncryptionService,
    private widgetStateService: WidgetStateService
  ) {}

  ngOnInit(): void {
    this.stateSubscription = this.widgetStateService.subject.subscribe((state) => {
      this.chatState = state;
    });
    this._authService.profileDetails.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: User | null) => {
        if (res) {
          this.profile = res;
        } else {
          this.profile = this._EncryptionService.decryptLocalStorage("profile");
        }
      },
    });
    if (this.profile) {
      this.email = this.profile.auth_id;
      this.name = this.profile.name;
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }

 
  clearLiveChatSession(): void {
    setTimeout(() => {
      if (typeof window !== "undefined" && window.LC_API) {
        console.log("Clearing LiveChat session...");
  
        window.LC_API.hide_chat_window?.();
  
        // Safe dynamic check for 'set_customer_data'
        if (typeof window.LC_API['set_customer_data'] === 'function') {
          window?.LC_API['set_customer_data'](null);
        } 
        // Optional: Check for 'set_custom_variables' if it's in your version
        else if (typeof window.LC_API['set_custom_variables'] === 'function') {
          window?.LC_API['set_custom_variables']([]);
        } else {
          console.warn("No method available to clear customer data.");
        }
      }
    }, 2000);
  }
  
  ngOnDestroy(): void {
    this.stateSubscription.unsubscribe(); // Avoid memory leaks
    this.clearLiveChatSession();
    console.log('destory');
  }
}
